/* global google */
import React from 'react'
import {
  GoogleMap,
  useLoadScript,
  GoogleMapProps,
  useGoogleMap,
  OverlayView,
  OverlayViewProps as _OverlayViewProps,
} from '@react-google-maps/api'

import { Box } from '../Box'
import { Text } from '../Text'
import { Skeleton } from '@chakra-ui/core'

const DEFAULT_CENTER = { lat: -27.8174082, lng: 135.9093002 }

export { useGoogleMap, OverlayView }

export interface OverlayViewProps extends _OverlayViewProps {}

//////////////////////

export interface GoogleMapsProps extends GoogleMapProps {
  height?: string
  width?: string
  zoom?: number
  children: React.ReactNode
}

export const GoogleMaps = ({
  height = '100%',
  width = '100%',
  mapContainerStyle,
  zoom = 3,
  center = DEFAULT_CENTER,
  onUnmount,
  id,
  children,
  ...restProps
}: GoogleMapsProps) => {
  return (
    <GoogleMap
      mapContainerStyle={{ height, width, ...mapContainerStyle }}
      center={center}
      zoom={zoom}
      {...restProps}
    >
      {children}
    </GoogleMap>
  )
}

export default GoogleMaps
